import * as base64 from 'crypto-js/enc-base64';
import * as crylib from 'crypto-js/lib-typedarrays';

export class Utils {
	public static random(bytes: number) {
		return crylib.random(bytes);
	}

	public static base64URLEncode(value) {
		return base64
			.stringify(value)
			.replace(/\+/g, '-')
			.replace(/\//g, '_')
			.replace(/=/g, '');
	}
}
